// extracted by mini-css-extract-plugin
export default {"container":"ove_18ZAS","inner":"ove_inn_3UBjC","thumbnail":"ove_thu_1tO_O","footer":"ove_foo_1oX2p","label":"ove_lab_2KwHB"};